import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import useSEO from '../common/useSEO';

export default function About() {
  useSEO({
    title: 'ABOUT — Aaron Figueroa',
    description: 'Founder & Videographer at Bay Area Podcast Studio. Delivering multi-cam video podcast production for founders, VPs, and enterprise leaders across the Bay Area.',
    path: '/about'
  });

  return (
    <div className="min-h-screen bg-[#000000] text-[#FFFFFF] font-sans selection:bg-[#FFFFFF] selection:text-[#000000]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <Nav />

        <main
          className="w-full"
          style={{ paddingTop: '4rem', paddingBottom: '6rem' }}
        >
          <div
            className="grid grid-cols-1 md:grid-cols-[55%_45%] gap-12 lg:gap-20"
            style={{ alignItems: 'flex-start' }}
          >

            {/* ── Left Column ── */}
            <div className="flex flex-col order-2 md:order-1">
              <h1
                className="about-heading font-bold uppercase text-[#FFFFFF]"
                style={{
                  fontSize: 'clamp(2rem, 3.5vw, 3.2rem)',
                  fontWeight: 700,
                  letterSpacing: '-0.01em',
                  lineHeight: 1.1,
                  marginBottom: '2rem',
                }}
              >
                FOUNDER &<br />VIDEOGRAPHER
              </h1>

              <div className="flex flex-col gap-5">
                <p className="about-p1" style={{ fontSize: '1.1rem', lineHeight: 1.7, color: '#DDDDDD' }}>
                  Founder of Bay Area Podcast Studio, one of the pioneering video podcast spaces in the Bay Area.
                </p>
                <p className="about-p2" style={{ fontSize: '1.1rem', lineHeight: 1.7, color: '#DDDDDD' }}>
                  I work with founders, VPs, and enterprise executives looking to tell their stories without technical friction. Built around my Touch Nothing Standard, you step into the room and focus entirely on your content while I handle the cameras, lighting, and production.
                </p>
                <p className="about-p3" style={{ fontSize: '1.1rem', lineHeight: 1.7, color: '#DDDDDD' }}>
                  Specializing in video podcasts, in-depth interviews, and executive messaging.
                </p>
              </div>

              {/* CTA */}
              <div className="about-cta" style={{ marginTop: '2.5rem' }}>
                <Link
                  to="/contact"
                  className="inline-block bg-[#FFFFFF] text-[#000000] uppercase font-semibold tracking-[0.1em] transition-opacity duration-300 hover:opacity-80"
                  style={{
                    padding: '0.85rem 1.75rem',
                    fontSize: '0.85rem',
                    fontWeight: 600,
                    letterSpacing: '0.1em',
                    borderRadius: '2px',
                  }}
                >
                  SEND A MESSAGE
                </Link>
              </div>
            </div>

            {/* ── Right Column: Portrait ── */}
            <div
              className="about-portrait w-full order-1 md:order-2"
              style={{
                backgroundColor: '#000000',
                overflow: 'hidden',
              }}
            >
              <img
                src="https://media-manager-c.questera.ai/greta-media/9c95a892991f8bee90ef212226d1d2edf0307c7f7bf17171a7a0344a5d4721a708ad3a9cb23f146c83b11da91425b5a8/images/aW1hZ2UvcG5n/387bd1d6e0f2dc541c3ad1ab2253d08f.png"
                alt="Aaron Figueroa"
                className="w-full max-h-[380px] md:max-h-[520px] object-cover object-top"
                style={{
                  display: 'block',
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                  maskImage: 'radial-gradient(ellipse at 50% 45%, #000000 55%, transparent 98%)',
                  WebkitMaskImage: 'radial-gradient(ellipse at 50% 45%, #000000 55%, transparent 98%)',
                }}
              />
            </div>

          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}